export default __webpack_public_path__ + "static/media/flag-palau.04092722.svg";